import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { CNAEIndicadorPrincipalBadgeComponent } from './principal';
import { CNAEIndicadorSecundariaBadgeComponent } from './secundaria';
import { CNAEIndicadorBadgesComponent } from './cnae-indicador-badges.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        CNAEIndicadorPrincipalBadgeComponent,
        CNAEIndicadorSecundariaBadgeComponent,
        CNAEIndicadorBadgesComponent
    ],
    exports: [
        CNAEIndicadorPrincipalBadgeComponent,
        CNAEIndicadorSecundariaBadgeComponent,
        CNAEIndicadorBadgesComponent
    ]
})
export class CNAEIndicadorBadgesModule { }
